/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：679__part-0
 */

"use strict"

var r = {
  "zh-CN": {
    widget: "控件",
    widgetName: "按钮",
    button: "按钮",
    text: "文本 ",
    textContent: "文本 内容 ",
    textColor: "文本 颜色 ",
    backgroundColor: "模版 颜色",
    maxFontSize: "文本 最大字号 ",
    textAlign: "文本 对齐方式 ",
    left: "居左",
    center: "居中",
    right: "居右",
    icon: "图标",
    iconId: "图标 图形 ",
    iconColor: "图标 颜色 ",
    templateMode: "背景框 样式 为 模板",
    backgroundImage: "背景框 样式 为 图片",
    set: "设置",
    show: "显示",
    hide: "隐藏",
    width: "宽度",
    height: "高度",
    mode: "样式",
    general: "通用",
    returnValue: "返回值",
    color: "颜色 为",
    sizeType: "尺寸大小",
    rectangleFill: "矩形填充",
    rectangleOutline: "矩形边框",
    circleFill: "圆形填充",
    circleOutline: "圆形边框",
    onButtonPress: "被",
    pressMsg: "点击",
    pressInMsg: "按下",
    pressOutMsg: "松开",
    outOfRange: "嵌入积木数值超过取值范围"
  }
}
export { r }
